/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Deal_LostInputs */

const cs_enum_deal_lost = /** @type {(inputs: Enum_Deal_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obchod prohrán`)
};

const en_enum_deal_lost = /** @type {(inputs: Enum_Deal_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal lost`)
};

/**
* | output |
* | --- |
* | "Deal lost" |
*
* @param {Enum_Deal_LostInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_deal_lost = /** @type {((inputs?: Enum_Deal_LostInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Deal_LostInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_deal_lost(inputs)
	return cs_enum_deal_lost(inputs)
});